var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEatingPreparingFood(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 112,
    height: 112,
    viewBox: "0 0 112 112",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_06",
    "data-name": 6,
    transform: "translate(-499 -56.076)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2689",
    "data-name": "Rectangle 2689",
    width: 112,
    height: 112,
    rx: 21,
    transform: "translate(499 56.076)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eat",
    transform: "translate(502 78.546)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10574",
    "data-name": "Group 10574",
    transform: "translate(24.061 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_374",
    "data-name": "Ellipse 374",
    cx: 29.768,
    cy: 29.768,
    r: 29.768,
    transform: "translate(0 0)",
    fill: "#d8ecfe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12659",
    "data-name": "Path 12659",
    d: "M145.612,80.75a29.768,29.768,0,0,1-51.846,19.967A29.768,29.768,0,0,0,135.8,58.665,29.694,29.694,0,0,1,145.612,80.75Z",
    transform: "translate(-86.077 -50.982)",
    fill: "#c4e2ff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_375",
    "data-name": "Ellipse 375",
    cx: 20.752,
    cy: 20.752,
    r: 20.752,
    transform: "translate(9.016 9.016)",
    fill: "#989fd7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12660",
    "data-name": "Path 12660",
    d: "M178.976,123.176a20.752,20.752,0,0,1-36.443,13.579A20.752,20.752,0,0,0,171.8,107.484,20.7,20.7,0,0,1,178.976,123.176Z",
    transform: "translate(-128.457 -93.408)",
    fill: "#6a75b9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10578",
    "data-name": "Group 10578",
    transform: "translate(35.93 10.658)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12661",
    "data-name": "Path 12661",
    d: "M128.2,290.932l-.442-.058a2.387,2.387,0,0,1-2.054-2.679l4.037-30.562,5.175.684-4.037,30.562A2.387,2.387,0,0,1,128.2,290.932Z",
    transform: "translate(-125.687 -234.552)",
    fill: "#685e68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12662",
    "data-name": "Path 12662",
    d: "M140.295,260.581l-4.028,30.493a2.457,2.457,0,0,1-2.757,2.113l-.3-.04a2.439,2.439,0,0,1-1.333-.62,2.453,2.453,0,0,0,1.834-2.059l3.993-30.229Z",
    transform: "translate(-131.062 -236.816)",
    fill: "#554e56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12663",
    "data-name": "Path 12663",
    d: "M149,82.078l-5.2-.687a.7.7,0,0,0-.785.6l-1.562,11.821a4.566,4.566,0,0,0,1.9,4.377,1.635,1.635,0,0,1,.683,1.567l-.622,4.709,5.175.684.622-4.708a1.635,1.635,0,0,1,1.067-1.336,4.566,4.566,0,0,0,2.967-3.734L154.8,83.549a.7.7,0,0,0-.6-.785Z",
    transform: "translate(-139.353 -81.384)",
    fill: "#e2dee2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12664",
    "data-name": "Path 12664",
    d: "M185.156,90.976,183.594,102.8a4.566,4.566,0,0,1-2.968,3.734,1.631,1.631,0,0,0-1.066,1.336l-.623,4.709-2.6-.344L177,107.1a1.631,1.631,0,0,1,1.066-1.336,4.567,4.567,0,0,0,2.968-3.734L182.6,90.2a.687.687,0,0,0-.019-.274l1.978.261a.7.7,0,0,1,.6.784Z",
    transform: "translate(-169.705 -88.811)",
    fill: "#cbc4cc"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10577",
    "data-name": "Group 10577",
    transform: "translate(5.231 0.296)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10575",
    "data-name": "Group 10575"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12665",
    "data-name": "Path 12665",
    d: "M169.048,83.907l-1.4,10.619a1.01,1.01,0,0,1-1,.879,1.113,1.113,0,0,1-.133-.008,1.013,1.013,0,0,1-.871-1.135l1.4-10.62h0Z",
    transform: "translate(-165.632 -83.641)",
    fill: "#b5adb6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10576",
    "data-name": "Group 10576",
    transform: "translate(4.005 0.53)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12666",
    "data-name": "Path 12666",
    d: "M199.632,87.951l-1.4,10.619a1.011,1.011,0,0,1-1,.879.9.9,0,0,1-.133-.009,1.011,1.011,0,0,1-.871-1.135l1.4-10.619Z",
    transform: "translate(-196.216 -87.686)",
    fill: "#b5adb6"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10579",
    "data-name": "Group 10579",
    transform: "translate(60.047 6.336)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12667",
    "data-name": "Path 12667",
    d: "M340.579,290.741l-.443.047a2.387,2.387,0,0,1-2.628-2.12l-3.28-30.652,5.191-.555,3.28,30.652A2.387,2.387,0,0,1,340.579,290.741Z",
    transform: "translate(-331.035 -230.08)",
    fill: "#685e68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12668",
    "data-name": "Path 12668",
    d: "M357.716,290.747l-.3.032a2.453,2.453,0,0,1-1.453-.294,2.458,2.458,0,0,0,1.311-2.442l-3.242-30.306,2.6-.278,3.272,30.584A2.456,2.456,0,0,1,357.716,290.747Z",
    transform: "translate(-348.241 -230.079)",
    fill: "#554e56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12669",
    "data-name": "Path 12669",
    d: "M318.222,75.761l-5.191.555-.4-3.755a2.437,2.437,0,0,0-.845-1.6l-1.088-.925a2.436,2.436,0,0,1-.856-1.973l.829-17.366a2.436,2.436,0,0,1,4.856-.143Z",
    transform: "translate(-309.837 -48.38)",
    fill: "#e2dee2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12670",
    "data-name": "Path 12670",
    d: "M329.806,75.765l-2.594.278-2.7-25.2a2.433,2.433,0,0,0-1.349-1.927,2.42,2.42,0,0,1,1.261-.519,2.44,2.44,0,0,1,2.682,2.163Z",
    transform: "translate(-321.42 -48.384)",
    fill: "#cbc4cc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10581",
    "data-name": "Group 10581",
    transform: "translate(22.405 3.741)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12671",
    "data-name": "Path 12671",
    d: "M408.434,28.773c-.514,1.639-1.848,4.618-4.958,5.781a.3.3,0,0,0,0,.555c3.11,1.163,4.444,4.142,4.958,5.781a.3.3,0,0,0,.568,0c.514-1.639,1.848-4.618,4.958-5.781a.3.3,0,0,0,0-.555c-3.11-1.163-4.444-4.142-4.958-5.781A.3.3,0,0,0,408.434,28.773Z",
    transform: "translate(-353.406 -28.565)",
    fill: "#fdb441"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12672",
    "data-name": "Path 12672",
    d: "M439.774,35.11c-3.11,1.163-4.444,4.141-4.957,5.781a.3.3,0,0,1-.569,0,11.168,11.168,0,0,0-1.258-2.708c.575-1.224.495-2.428,2.221-3.073a.3.3,0,0,0,0-.555c-1.726-.646-1.646-1.85-2.221-3.074a11.163,11.163,0,0,0,1.258-2.707.3.3,0,0,1,.569,0c.513,1.638,1.847,4.617,4.957,5.781A.3.3,0,0,1,439.774,35.11Z",
    transform: "translate(-379.22 -28.565)",
    fill: "#fea613"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10580",
    "data-name": "Group 10580",
    transform: "translate(0 47.879)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12673",
    "data-name": "Path 12673",
    d: "M26.49,394.332a6.962,6.962,0,0,1-3.935,4.588.236.236,0,0,0,0,.441,6.962,6.962,0,0,1,3.935,4.588.236.236,0,0,0,.451,0,6.962,6.962,0,0,1,3.935-4.588.236.236,0,0,0,0-.441,6.962,6.962,0,0,1-3.935-4.588A.236.236,0,0,0,26.49,394.332Z",
    transform: "translate(-22.405 -394.167)",
    fill: "#fdb441"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12674",
    "data-name": "Path 12674",
    d: "M51.362,399.36a6.959,6.959,0,0,0-3.934,4.588.237.237,0,0,1-.451,0,8.864,8.864,0,0,0-1-2.149c.456-.971.393-1.927,1.762-2.439a.236.236,0,0,0,0-.441c-1.37-.513-1.306-1.469-1.762-2.44a8.857,8.857,0,0,0,1-2.148.237.237,0,0,1,.451,0,6.962,6.962,0,0,0,3.934,4.588A.236.236,0,0,1,51.362,399.36Z",
    transform: "translate(-42.891 -394.166)",
    fill: "#fea613"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEatingPreparingFood);
export default __webpack_public_path__ + "static/media/eatingPreparingFood.42f91df73b2849228b5019fa0ddd6783.svg";
export { ForwardRef as ReactComponent };